import SharedGlobalStyles from '@helios/shared/styles/shared-global-styles'

export default SharedGlobalStyles
